import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import {
  trackAppDownloadClick,
  type AppDownloadPlatform,
} from "@/lib/app-download";

export type { AppDownloadPlatform };
export {
  APP_DOWNLOAD_CLICK_API,
  APP_STORE_URLS,
  REALTORSIN_SITE_URL,
  openAppStoreAfterTrack,
  trackAppDownloadClick,
  trackAppStoreClick,
} from "@/lib/app-download";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Detects the user's platform (Android, iOS, or Web)
 */
export function detectPlatform(): "android" | "ios" | "web" {
  if (typeof window === "undefined") return "web";

  const userAgent = window.navigator.userAgent.toLowerCase();

  // Check for Android
  if (/android/.test(userAgent)) {
    return "android";
  }

  // Check for iOS (iPhone, iPad, iPod)
  if (/iphone|ipad|ipod/.test(userAgent)) {
    return "ios";
  }

  // Default to web
  return "web";
}

/**
 * Detects the browser name from user agent
 */
export function detectBrowser(): string {
  if (typeof window === "undefined") return "Unknown";

  const userAgent = window.navigator.userAgent;

  if (userAgent.includes("Chrome") && !userAgent.includes("Edg") && !userAgent.includes("OPR")) {
    return "Chrome";
  }
  if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    return "Safari";
  }
  if (userAgent.includes("Firefox")) {
    return "Firefox";
  }
  if (userAgent.includes("Edg")) {
    return "Edge";
  }
  if (userAgent.includes("OPR")) {
    return "Opera";
  }
  if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
    return "Internet Explorer";
  }

  return "Unknown";
}

/**
 * Tracks a download click by calling the RealtorsIn API.
 * @deprecated Prefer trackAppDownloadClick from @/lib/app-download
 */
export async function trackDownloadClick(
  platform: AppDownloadPlatform
): Promise<boolean> {
  return trackAppDownloadClick(platform);
}
